import {Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DxGridOptions} from "../../../../dx-grid/domain/ui-options/dx-grid-options";
import {DxGridRow} from "../../../../dx-grid/domain/dx-grid-row";
import {DxGridComponent} from "../../../../dx-grid/ui/components/dx-grid-component";
import {PitFile} from "../../../../pit-shared/domain/pit-file";
import {DxModalResultType} from "../../../../dx-modals/domain/dx-modal-result-type";
import {Observable} from "rxjs";
import {PitFileUploadModalComponent} from "../file-upload-modal/pit-file-upload-modal.component";
import {BdpkFileService} from "../../../../bdpk-common/services/bdpk-file.service";
import {DxModalService} from "../../../../dx-modals/services/dx-modal.service";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";

@Component({
  selector: 'pit-files',
  templateUrl: './pit-files.component.html',
  styleUrls: ['./pit-files.component.css']
})
export class PitFilesComponent implements OnInit {

  @Input()
  readOnly: boolean;

  @Input()
  filesGridOptions: DxGridOptions;

  @Input()
  filesGridData: PitFile[] = [];

  @Output()
  filesGridDataChanged = new EventEmitter<PitFile[]>();

  @ViewChild('filesGrid', {static: false})
  filesGrid: DxGridComponent;
  filesSelectedRow: PitFile;

  constructor(private fileService: BdpkFileService,
              private configService: BdpkConfigService,
              private modalsService: DxModalService,
              private resolver: ComponentFactoryResolver) { }

  ngOnInit() {
    this.filesGridOptions = this.configService.bdpkFilesGridOptions;
  }


  onFileDelete(): void {
    const index = this.filesGridData.findIndex(item => item.fileId === this.filesSelectedRow.fileId);
    this.filesGridData.splice(index, 1);
    this.filesGrid.state.clearSelected();
    this.filesGridDataChanged.emit(this.filesGridData = [...this.filesGridData]);
  }

  onFileDownload(): void {
    this.fileService.downloadFile(this.filesSelectedRow.fileId);
  }

  onFilesRowSelect(value): void {
    this.filesSelectedRow = value.data[0];
  }

  onFilesRowDeselect(value): void {
    this.filesSelectedRow = null;
  }

  onFileLoad(): void {
    this._showFileLoadForm().subscribe(event => {

      if (DxModalResultType.SAVE !== event.type) {
        return;
      }
      const result = event.data as Map<string, any>;
      if (result) {
        this.fileService.uploadFile(result.get('ctrlFile'), result.get('ctrlFile').name).subscribe(
          file => {
            // добавляем строку к таблице прикрепленных файлов
            let row = PitFile.fromLoadedFile(file, result.get('ctrlDocumentType'), null)
              .setComment(result.get('ctrlNote'));
            this.filesGrid.state.clearSelected();
            this.filesGridDataChanged.emit(this.filesGridData = [...this.filesGridData, row]);
          });
      }
    });
  }

  private _showFileLoadForm(): Observable<any> {
    const factory = this.resolver.resolveComponentFactory(PitFileUploadModalComponent);
    const options = this.modalsService.buildEditModalOptions('tiny', 'Прикрепить');

    return this.modalsService.showEditByFactory(factory, null, 'Прикрепить файл', options)
  }

}
